import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { getCase } from "./services/airtable";

export function useCase() {
  const { caseId } = useParams();

  const {
    isLoading: isLoadingCase,
    data: caseData,
    error,
  } = useQuery({
    queryKey: ["case", caseId],
    queryFn: () => getCase(caseId),
  });

  return { isLoadingCase, caseData, error };
}
